module.exports = __webpack_public_path__ + "static/media/m3logo.ea456d49.svg";